changeMajor
<template>
  <div>
    <el-form @submit.native.prevent="saveEditTests" :inline="true">
      <el-form-item label="选择网校">
        <el-select
          v-model="model.maID"
          multiple
          @change="changeMajor"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          v-model="model.clID"
          @change="changeClass"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加班级">
        <el-select v-model="model._id" placeholder="班级">
          <el-option
            v-for="item in getgrade"
            :key="item.index"
            :label="item.grName"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加考试大纲">
        <el-select v-model="model.lineID" multiple placeholder="添加考试大纲">
          <el-option
            v-for="item in outline"
            :key="item.outline"
            :label="item.lineName"
            :value="item.lineID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加备考指导">
        <el-select v-model="model.advID" multiple placeholder="备考指导">
          <el-option
            v-for="item in advice"
            :key="item.index"
            :label="item.advName"
            :value="item.advID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="请勿修改题库testsID">
        <el-input :disabled="true" v-model="model.testsID"></el-input>
      </el-form-item>
      <el-form-item label="课程名称">
        <el-input style="width: 550px" v-model="model.testsName"></el-input>
      </el-form-item>

      <el-card style="margin-top: 25px">
        <!-- 上传封面图 -->
        <h3>上传课程主图</h3>
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/tests/img/cover'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="coUpload"
        >
          <div>
            <img
              v-show="showCoImg"
              style="width: 480px; height: 300px"
              :src="model.testsCoverImg"
            />
          </div>
          <el-button size="small" type="primary">点击封面图</el-button>
        </el-upload>
        <el-form-item style="margin-top: 35px" label="详情图网址">
          <el-input
            style="width: 550px"
            v-model="model.testsCoverImg"
          ></el-input>
        </el-form-item>
      </el-card>

      <el-card style="margin-top: 25px">
        <!-- 上传课程详情图 -->
        <h3>上传课程详情图</h3>
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/tests/img/desc'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="leUpload"
        >
          <div>
            <img
              v-show="showLeImg"
              style="width: 650px; height: 100%"
              :src="model.testsDescImg"
            />
          </div>
          <el-button size="small" type="primary">点击上传详情图</el-button>
        </el-upload>
        <el-form-item style="margin-top: 35px" label="详情图网址">
          <el-input
            style="width: 550px"
            v-model="model.testsDescImg"
          ></el-input>
        </el-form-item>
      </el-card>

      <el-form-item style="margin-top: 25px; margin-bottom: 25px; float: right">
        <el-button type="primary" native-type="submit">点击修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showCoImg: true,
      showLeImg: true,
      dataNum: 1,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      getgrade: [],
      advice: [],
      outline: [],
      testsID: 0,
      model: {
        testsName: "",
        testsCoverImg: "",
        testsDescImg: "",
      },
    };
  },
  methods: {
    async saveEditTests() {
      try {
        const params = {
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          advID: this.model.advID,
          lineID: this.model.lineID,
          testsID: this.model.testsID,
          testsName: this.model.testsName,
          testsCoverImg: this.model.testsCoverImg,
          testsDescImg: this.model.testsDescImg,
          gradeID: this.model._id,
        };
        await this.$http.put("/tests/puttests?_id=" + `${this.id}`, params);
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.$router.push("/tests/list");
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        //console.log(item);
        const getcourse = await this.$http.get(
          "/category/getcourse",
          {
            params: { chID },
          },
          this.getGrade(chID),
          this.getAdvice(chID),
          this.getOutline(chID)
        );
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
        this.getGrade(coID);
        this.getAdvice(coID);
        this.getOutline(coID);
      } catch (error) {
        console.log(error);
      }
    },
    async changeClass(clID) {
      this.getAdvice(clID), this.getOutline(clID);
    },
    changeMajor() {
      this.getGrade();
    },
    async getOutline() {
      try {
        let params = {
          chID: this.model.chID,
          coID: this.model.coID,
          size: this.pageSize,
        };
        const result = await this.$http.get("/outline/getline", {
          params,
        });

        this.outline = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
    },
    async getAdvice() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          size: this.pageSize,
        };
        const result = await this.$http.get("/advice/getadvice", {
          params,
        });

        this.advice = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
      //console.log(this.getgrade);
    },
    async getGrade() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          clID: this.model.clID,
        };
        //console.log(params);
        const getGrade = await this.$http.get("/category/getgrade", {
          params,
        });
        //console.log(getGrade.data[0].result);
        this.getgrade = getGrade.data[0].result;
        //console.log(this.getgrade);
      } catch (error) {
        console.log(error);
      }
    },
    leUpload(res) {
      try {
        //console.log(res.detailImg);
        this.model.testsDescImg = res;
        this.showLeImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    coUpload(res) {
      try {
        //console.log(res.coverImg);
        this.model.testsCoverImg = res;
        this.showCoImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      //console.log(file);
    },
    handleRemove(uploadFile, uploadFiles) {
      //.log(uploadFile, uploadFiles);
    },

    //课程编辑
    async getEditTests() {
      try {
        const getEditLesson = await this.$http.get("/tests/edittests", {
          params: { id: this.id },
        });
        this.model.maID = getEditLesson.data[0].maID;
        this.model.chID = getEditLesson.data[0].chID;
        this.model.coID = getEditLesson.data[0].coID;
        this.model.clID = getEditLesson.data[0].clID;
        this.model.advID = getEditLesson.data[0].advID;
        this.model.lineID = getEditLesson.data[0].lineID;
        this.model.testsID = getEditLesson.data[0].testsID;
        this.model.testsName = getEditLesson.data[0].testsName;
        this.model.testsID = getEditLesson.data[0].testsID;
        this.model.testsDescImg = getEditLesson.data[0].testsDescImg;
        this.model.testsCoverImg = getEditLesson.data[0].testsCoverImg;
        this.getgrade = getEditLesson.data[0].grade;
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.getMajor();
    this.getChannel();

    this.id && this.getEditTests(this.id);
  },
};
</script>

<style scoped></style>
